import { resourcePath } from '@gameday/utils/resource-path';
let DFVOverrideId;
let DFVDVROverride;

if (typeof URLSearchParams !== 'undefined' && typeof location !== 'undefined') {
    const params = new URLSearchParams(location.search);
    const idOverride = params.get('DFVOverride');
    const dvrOverride = params.get('useDFVDVR');
    if (idOverride !== null && !isNaN(idOverride)) {
        DFVOverrideId = idOverride;
    }
    if (dvrOverride !== null && (dvrOverride === 'true' || dvrOverride === 'false')) {
        DFVDVROverride = !!dvrOverride;
    }
}

const buildFieldViewStream = ({
    venueId,
    useDVR = false,
    gamePk
}) => {
    const streamURL = !(DFVDVROverride ?? useDVR) ? resourcePath.get('dynamicFieldView', { venueId: DFVOverrideId ?? venueId, gamePk }) : resourcePath.get('dynamicFieldViewDVR', { venueId: DFVOverrideId ?? venueId, gamePk });

    return {
        id: `dynamic-field-view-${venueId}-stream`,
        url: streamURL // 'https://devstreaming-cdn.apple.com/videos/streaming/examples/bipbop_16x9/bipbop_16x9_variant.m3u8'
    };
};

export default buildFieldViewStream;
